<template>
    <div>
        <template v-if="isPageReady && firstProgressComplete">

            <h1 class="page__title">{{ $t("your-match-with-x", {x: capitalize(partnerName)}) }}</h1>

            <timing-section
                v-if="userTimeline && partnerTimeline"
                :user-timeline="userTimeline"
                :partner-timeline="partnerTimeline" />

            <potential-section
                v-if="potentialData"
                :active-point="potentialData" />

            <FullfillmentSection
                v-if="fullfillmentData"
                :user-id="currentUser.id_person"
                :partner-id="id"
                :fullfillment-data="fullfillmentData" />

            <balance-section
                v-if="balanceData"
                :balance-data="balanceData" />

            <gift-section
                v-if="giftsData"
                :gifts-data="giftsData" />

            <elements-section
                v-if="elementsData"
                :elements-data="elementsData" />


            <div>

                <div class="grid">
                    <div class="grid__item desktop--6">
                        <leader-section
                            :key="leaderDataKey"
                            v-if="leaderData"
                            :leader-data="leaderData" />
                    </div>
                    <div class="grid__item desktop--6">
                        <exclusivity-section
                            :key="exclusivityDataKey"
                            v-if="exclusivityData"
                            :exclusivity-data="exclusivityData" />
                    </div>
                </div>
            </div>

            <UnderstandingSection
                v-if="understandingData"
                :understanding-data="understandingData" />

            <AttractionSection
                v-if="attractionData"
                :attraction-data="attractionData" />

            <WinnerSection
                v-if="winnerData"
                :data="winnerData" />

            <!--  <CommunicationSection
                v-if="communicationData"
                :partner-id="id"
                :communication-data="communicationData" /> -->

            <SentimentalPotentialSection
                :data="sentimentalPotentialData"
                :partner-id="id"
                :user-id="currentUser.id_person" />

            <ResemblanceSection
                v-if="resemblanceData"
                :active-point="resemblanceData" />

            <!-- <StarSection
                :user="currentUser"
                v-if="starData"
                :data="starData" /> -->

            <!-- <div
                id="section-outro"
                class="one-to-one__section">

                <ul class="buttons-list buttons-list--centered">
                    <li class="buttons-list__item">
                        <button
                            type="button"
                            @click="$emit('reset-partner')"
                            class="button button--primary">
                            <span class="button__label">{{ $t("change-profile") }}</span>
                        </button>
                    </li>
                </ul>
            </div> -->

        </template>
        <template v-else>
            <div class="loader">
                <template v-if="hasError">
                    <p>{{ $t("a-server-error-occured-please-try-later") }}</p>
                </template>
                <template v-else>
                    <template v-if="partner">
                        <template v-if="firstProgressComplete">
                            <HorizontalBubbleLoader />
                        </template>
                        <template v-else>
                            <QuotesLoader
                                ref="progressLoader"
                                :max="50"
                                @progress-complete="firstProgressComplete = true" />
                        </template>
                    </template>
                </template>
            </div>
        </template>
    </div>
</template>

<script>

import { getCompare, getMeTimeline, getUserInfo } from "@/utils/api/usersApi.js";


import TimingSection from "@/components/match/one-to-one-section/TimingSection.vue";
import GiftSection from "@/components/match/one-to-one-section/GiftSection.vue";
import ElementsSection from "@/components/match/one-to-one-section/ElementsSection.vue";
import BalanceSection from "@/components/match/one-to-one-section/BalanceSection.vue";
import LeaderSection from "@/components/match/one-to-one-section/LeaderSection.vue";
import ExclusivitySection from "@/components/match/one-to-one-section/ExclusivitySection.vue";
import FullfillmentSection from "@/components/match/one-to-one-section/FullfillmentSection.vue";
import UnderstandingSection from "@/components/match/one-to-one-section/UnderstandingSection.vue";
import AttractionSection from "@/components/match/one-to-one-section/AttractionSection.vue";
//import CommunicationSection from "@/components/match/one-to-one-section/CommunicationSection.vue";
import SentimentalPotentialSection from "@/components/match/one-to-one-section/SentimentalPotentialSection.vue";
import WinnerSection from "@/components/match/one-to-one-section/WinnerSection.vue";
import ResemblanceSection from "@/components/match/one-to-one-section/ResemblanceSection.vue";
import PotentialSection from "@/components/match/one-to-one-section/PotentialSection.vue";
//import StarSection from "@/components/match/one-to-one-section/StarSection.vue";
import HorizontalBubbleLoader from "@/components/loaders/HorizontalBubbleLoader.vue";
import QuotesLoader from "@/components/loaders/QuotesLoader.vue";

export default {
    name: "OneToOne",
    components: {
        "TimingSection": TimingSection,
        "PotentialSection": PotentialSection,
        "GiftSection": GiftSection,
        "ElementsSection": ElementsSection,
        "BalanceSection": BalanceSection,
        "LeaderSection": LeaderSection,
        "ExclusivitySection": ExclusivitySection,
        "FullfillmentSection": FullfillmentSection,
        "UnderstandingSection": UnderstandingSection,
        "AttractionSection": AttractionSection,
        //"CommunicationSection": CommunicationSection,
        "SentimentalPotentialSection": SentimentalPotentialSection,
        //"StarSection": StarSection,
        "WinnerSection": WinnerSection,
        "ResemblanceSection": ResemblanceSection,
        "HorizontalBubbleLoader": HorizontalBubbleLoader,
        "QuotesLoader": QuotesLoader,
    },
    props: {
        id: {
            type: String,
            required: true
        },
        currentUser: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            leaderDataKey: 0,
            exclusivityDataKey: 0,
            fetchPartnerTimelineTentative: 0,
            fetchUserTimelineTentative: 0,
            partnerTimeline: null,
            userTimeline: null,
            partner: null,
            firstProgressComplete: false,
            hasError: false,
        };
    },
    computed: {
        userComparison() {
            return this.$store.getters["userModule/getComparison"];
        },
        partnerName() {
            if (this.partner) {
                return this.partner.fname;
            }
        },
        timingData() {
            return false;
        },
        potentialData() {
            if (this.userComparison) {
                return this.userComparison.find((item) => {
                    return item.report_name === "equilibre" && item.same_id_person === this.id;
                });
            }

            return;
        },
        giftsData() {
            if (this.userComparison) {
                return this.userComparison.filter((item) => {
                    return item.report_name === "gift" && item.same_id_person === this.id;
                });
            }
        },
        elementsData() {
            if (this.userComparison) {
                return this.userComparison.find((item) => {
                    return item.report_name === "entente_generale" && item.same_id_person === this.id;
                });
            }
        },
        balanceData() {
            if (this.userComparison) {
                return this.userComparison.find((item) => {
                    return item.report_name === "equilibre" && item.same_id_person === this.id;
                });
            }
        },
        leaderData() {
            if (this.userComparison) {
                return this.userComparison.filter((item) => {
                    if (item.report_name === "boss") {
                        return item.same_id_person === this.currentUser.id_person || item.same_id_person === this.id;
                    }
                });
            }
        },
        exclusivityData() {
            if (this.userComparison) {
                return this.userComparison.filter((item) => {
                    if (item.report_name === "exclusif") {
                        return item.same_id_person === this.currentUser.id_person || item.same_id_person === this.id;
                    }
                });
            }
        },
        fullfillmentData() {
            if (this.userComparison) {
                return this.userComparison.filter((item) => {
                    if (item.report_name === "bulle_search" || item.report_name === "fill") {
                        return item.id_person === this.currentUser.id_person || item.id_person === this.id;
                    }
                });
            }
        },
        understandingData() {
            if (this.userComparison) {
                return this.userComparison.find((item) => {
                    return item.report_name === "1to1_ententeIntel" && item.same_id_person === this.id;
                });
            }
        },
        attractionData() {
            if (this.userComparison) {
                return this.userComparison.find((item) => {
                    return item.report_name === "attraction" && item.same_id_person === this.id;
                });
            }
        },
        /*communicationData() {
            if (this.userComparison) {
                return this.userComparison.filter((item) => {
                    return item.report_name === "communication" && (item.id_person === this.id || item.id_person === this.currentUser.id_person);
                });
            }
        },*/
        sentimentalPotentialData() {
            if (this.userComparison) {
                return this.userComparison.filter((item) => {
                    return item.report_name === "potentiel" && (item.id_person === this.id || item.id_person === this.currentUser.id_person);
                });
            }
        },
        winnerData() {
            if (this.userComparison) {
                const winnerData = this.userComparison.find((item) => {
                    return item.report_name === "winner" && (item.same_id_person === this.id && item.id_person === this.currentUser.id_person);
                });

                return winnerData;
            }
        },
        resemblanceData() {
            if (this.userComparison) {
                const resemblanceData = this.userComparison.find((item) => {
                    return item.report_name === "ressemblance" && (item.same_id_person === this.id && item.id_person === this.currentUser.id_person);
                });

                return resemblanceData;
            }
        },
        isPageReady() {
            if (this.userComparison && this.userTimeline && this.partnerTimeline) {
                return true;
            }

            return false;
        },

        
        /*starData() {
            if (this.userComparison) {

                const data = this.userComparison.filter((item) => {
                    return item.report_name === "star_distance" && (item.id_person === this.id || item.id_person === this.currentUser.id_person);
                });

                return data;
            }
        }*/
    },
    watch: {
        leaderData(val, oldVal) {
            if (val !== oldVal) {
                // To force releod of the leaderComponent, use the :key increment trick
                // https://michaelnthiessen.com/force-re-render/
                this.leaderDataKey += 1;
            }
        },
        exclusivityData(val, oldVal) {
            if (val !== oldVal) {
                // To force releod of the exclusivityComponent, use the :key increment trick
                // https://michaelnthiessen.com/force-re-render/
                this.exclusivityDataKey += 1;
            }
        },
        partner(val, oldVal) {
            if (val !== oldVal) {
                this.firstProgressComplete = val.timelineinit;

                if (!this.userComparison) {
                    this.fetchUserComparison();
                }

                if (!this.userTimeline) {
                    this.fetchUserTimeline();
                }

                if (!this.partnerTimeline) {
                    this.fetchPartnerTimeline();
                }
            }
        },
        isPageReady() {
            if (!this.firstProgressComplete) {
                this.$refs.progressLoader.finish();
            }
        },
        id(val, oldVal) {
            if (val !== oldVal) {
                this.fetchPartnerInfo();
            }
        }
    },
    mounted() {
        this.fetchPartnerInfo();
    },
    methods: {
        fetchUserComparison() {
            const user = {
                "id": this.currentUser.id_person
            };

            getCompare(user).then((res) => {
                if (res.status === 200 && res.data) {
                    this.$store.commit("userModule/setComparison", res.data);
                } else {
                    this.hasError = true;
                }
            });
        },
        fetchUserTimeline() {
            this.fetchUserTimelineTentative += 1;

            const maxTentative = (this.firstProgressComplete) ? 5 : 50;

            // fetch User Timeline
            const user = {
                "id": this.currentUser.id_person
            };

            getMeTimeline(user).then((res) => {
                if (res.status === 200 && res.data) {
                    this.userTimeline = res.data.part1;
                } else {
                    if (this.fetchUserTimelineTentative <= maxTentative && (!res.data || (res.data && res.data.length === 0))) {
                        this.fetchUserTimeline();
                    } else {
                        this.hasError = true;
                    }
                }
            });
        },
        fetchPartnerTimeline() {
            this.fetchPartnerTimelineTentative += 1;

            const maxTentative = (this.firstProgressComplete) ? 5 : 50;

            // fetch User Timeline
            const user = {
                "id": this.id
            };

            getMeTimeline(user).then((res) => {
                if (res.status === 200 && res.data) {
                    this.partnerTimeline = res.data.part1;
                } else {
                    if (this.fetchPartnerTimelineTentative <= maxTentative && (!res.data || (res.data && res.data.length === 0))) {
                        this.fetchPartnerTimeline();
                    } else {
                        this.hasError = true;
                    }
                }
            });
        },
        fetchPartnerInfo() {
            const user = {
                id: this.id
            };

            getUserInfo(user).then((res) => {
                if (res.status === 200 && res.data) {
                    this.partner =  res.data;
                } else {
                    this.hasError = true;
                }
            });
        }
    }
};
</script>

